import {useQuery, gql} from "@apollo/client";
var  BLOG_DETAIL = gql`
query BlogList($contentItemId: ID) {
    blog(where: {contentItemId: $contentItemId, localization: {culture_starts_with: "fa"}}) {
      contentItemId
      displayText
      htmlBody {
        html
      }
      bag {
        contentItems {
          ... on BlogImage {
            createdUtc
            displayText
            blogImageField {
              urls(first: 1)
            }
          }
        }
      }
      blogOverview {
        html
      }
      blogAuthor
      blogCreateDate
      alias {
        alias
      }
      blogPageHeaderImage {
        urls(first: 1)
      }
    }
  }
`;

export const useBlogDetail = (contentItemId) => {
  const {error, loading, data} = useQuery(BLOG_DETAIL, { variables: {contentItemId:contentItemId}});
  
  return {
    error, data, loading
  };
  } 